// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-pricelabel_default__32jph","knockout":"idt-pricelabel_knockout__hswgp"};